// @ts-nocheck
// import React from 'react'
import { retrieveSchema, toIdSchema, mergeObjects, getDefaultFormState } from "../../../utils";
import validateFormData from "../../../validate";
import FormNativeDefault from "./default";

class FormNative extends FormNativeDefault {
  validate(formData, schema = this.props.schema, additionalMetaSchemas = this.props.additionalMetaSchemas, customFormats = this.props.customFormats) {
    const {
      validate,
      transformErrors
    } = this.props;
    const {
      rootSchema
    } = this.getRegistry();
    const resolvedSchema = retrieveSchema(schema, rootSchema, formData);
    return validateFormData(formData, resolvedSchema, validate, transformErrors, additionalMetaSchemas, customFormats);
  }

  getStateFromProps(props, inputFormData) {
    var _this$state;

    const state = (_this$state = this.state) !== null && _this$state !== void 0 ? _this$state : {};
    const schema = 'schema' in props ? props.schema : this.props.schema;
    const uiSchema = 'uiSchema' in props ? props.uiSchema : this.props.uiSchema;
    const edit = typeof inputFormData !== 'undefined';
    const liveValidate = 'liveValidate' in props ? props.liveValidate : this.props.liveValidate;
    const mustValidate = edit && !props.noValidate && liveValidate;
    const rootSchema = schema;
    const formData = getDefaultFormState(schema, inputFormData, rootSchema);
    const retrievedSchema = retrieveSchema(schema, rootSchema, formData);
    const {
      customFormats
    } = props;
    const {
      additionalMetaSchemas
    } = props; // let { errors, errorSchema } = mustValidate
    //   ? this.validate(formData, schema, additionalMetaSchemas, customFormats)
    //   : {
    //     errors: state.errors ?? [],
    //     errorSchema: state.errorSchema ?? {},
    //   }
    // / ADDED****

    const getCurrentErrors = () => {
      var _state$errors, _state$errorSchema;

      if (props.noValidate) {
        return {
          errors: [],
          errorSchema: {}
        };
      }

      if (!props.liveValidate) {
        var _state$schemaValidati, _state$schemaValidati2;

        return {
          errors: (_state$schemaValidati = state.schemaValidationErrors) !== null && _state$schemaValidati !== void 0 ? _state$schemaValidati : [],
          errorSchema: (_state$schemaValidati2 = state.schemaValidationErrorSchema) !== null && _state$schemaValidati2 !== void 0 ? _state$schemaValidati2 : {}
        };
      }

      return {
        errors: (_state$errors = state.errors) !== null && _state$errors !== void 0 ? _state$errors : [],
        errorSchema: (_state$errorSchema = state.errorSchema) !== null && _state$errorSchema !== void 0 ? _state$errorSchema : {}
      };
    };

    let errors;
    let errorSchema;
    let schemaValidationErrors;
    let schemaValidationErrorSchema;

    if (mustValidate) {
      const schemaValidation = this.validate(formData, schema, additionalMetaSchemas, customFormats);
      errors = schemaValidation.errors;
      errorSchema = schemaValidation.errorSchema;
      schemaValidationErrors = errors;
      schemaValidationErrorSchema = errorSchema;
    } else {
      const currentErrors = getCurrentErrors();
      errors = currentErrors.errors;
      errorSchema = currentErrors.errorSchema;
      schemaValidationErrors = state.schemaValidationErrors;
      schemaValidationErrorSchema = state.schemaValidationErrorSchema;
    } // / ****ADDED


    if (props.extraErrors) {
      errorSchema = mergeObjects(errorSchema, props.extraErrors);
      errors = toErrorList(errorSchema);
    }

    const idSchema = toIdSchema(retrievedSchema, uiSchema['ui:rootFieldId'], rootSchema, formData, props.idPrefix);
    const nextState = {
      schema,
      uiSchema,
      idSchema,
      formData,
      edit,
      errors,
      errorSchema,
      additionalMetaSchemas
    };

    if (schemaValidationErrors) {
      nextState.schemaValidationErrors = schemaValidationErrors;
      nextState.schemaValidationErrorSchema = schemaValidationErrorSchema;
    }

    return nextState;
  }

}

export default FormNative;